import FreshwatchGroupCardGrid from '../../../../../../customized/fresh-watch/components/DeviceManager/GroupsOverview/GroupCardGrid/FreshwatchGroupCardGrid';
import { ToggleComponent } from '../../../../../../featureToggle';
import GroupCardGrid from './GroupCardGrid';

export default ToggleComponent(GroupCardGrid, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchGroupCardGrid,
  },
});
